/**
 * 成就系统引擎
 */

import type { PlayerState } from './Player';
import { ACHIEVEMENTS, type Achievement } from '../data/achievements';

export interface UnlockedAchievement {
  achievement: Achievement;
  timestamp: number;
}

/** 检查并解锁新成就，返回新解锁的列表 */
export function checkAchievements(player: PlayerState, extra?: any): Achievement[] {
  const unlocked: string[] = player.unlockedAchievements ?? [];
  const newly: Achievement[] = [];

  for (const ach of ACHIEVEMENTS) {
    if (unlocked.includes(ach.id)) continue;
    try {
      if (ach.check(player, extra)) {
        unlocked.push(ach.id);
        ach.applyReward(player);
        newly.push(ach);
      }
    } catch (_) { /* skip on error */ }
  }

  if (newly.length > 0) {
    (player as any).unlockedAchievements = unlocked;
  }

  return newly;
}

/** 获取已解锁成就列表 */
export function getUnlockedAchievements(player: PlayerState): Achievement[] {
  const ids = player.unlockedAchievements ?? [];
  return ACHIEVEMENTS.filter((a) => ids.includes(a.id));
}

/** 获取全部成就及其解锁状态 */
export function getAllWithStatus(player: PlayerState): { achievement: Achievement; unlocked: boolean }[] {
  const ids = player.unlockedAchievements ?? [];
  return ACHIEVEMENTS.map((a) => ({ achievement: a, unlocked: ids.includes(a.id) }));
}
